<modal-container
  #modal
  [isLargeModal]="true"
  [headerIconClass]="'fa-truck'"
  [headerTitle]="headerTitle"
  [modalHeaderBgColorClass]="headerBgClass"
  [modalBodyBgColorClass]="bodyBgClass"
  [modalFooterBgColorClass]="footerBgClass"
>
  <ng-container class="modal-button-show">
    <btn
      [classes]="['float-right', isUnloadingStock ? 'btn-first-red' : 'btn-first-green', 'mr-2']"
      (onEvent)="showChildModal()"
      [icon]="isUnloadingStock ? 'far-layer-minus' : 'far-layer-plus'"
      [label]="isUnloadingStock ? 'out' : 'in'"
      [title]="isUnloadingStock ? ('out' | translate) : ('in' | translate)"
    ></btn>
  </ng-container>

  <ng-container class="modal-body-content">
    <div class="card" style="padding: 26px 19px" *ngIf="!!childModal?.childModal?.isShown">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      <div class="form-stock-load" *ngIf="!loading">
        <div class="col-12">
          <div class="row">
            <div class="col-12 col-sm-6">
              <form-row-select
                [label]="'depot'"
                [icon]="'far-industry'"
                [isSelectDisabled]="!!currentStockItem"
                [options]="depots"
                [(model)]="productMove.depotTo"
                [required]="!this.isUnloadingStock && (!this.productMove.depotTo || this.productMove.depotTo < 1)"
                [requiredCssClass]="
                  submitted && !this.isUnloadingStock && (!this.productMove.depotTo || this.productMove.depotTo < 1)
                "
              >
              </form-row-select>
            </div>
            <div class="col-12 col-sm-6">
              <form-row-select
                [label]="'supplier'"
                [icon]="'far-truck'"
                [(model)]="productMove.supplier"
                [isSelectDisabled]="!!currentStockItem"
                [options]="suppliers"
                [required]="!this.isUnloadingStock && !this.productMove.supplier"
                [requiredCssClass]="submitted && !this.isUnloadingStock && !this.productMove.supplier"
              >
              </form-row-select>
            </div>
          </div>
          <div class="row" *ngIf="product?.enabledBatchExpiration">
            <div class="col-12 col-sm-6">
              <form-row-input
                [label]="'product.batch'"
                [icon]="'far-cubes'"
                [(model)]="productMove.batch"
                [inputDisabled]="!!currentStockItem"
              ></form-row-input>
            </div>
            <div class="col-12 col-sm-6">
              <form-row-input
                [inputType]="'date'"
                [label]="'product.expirationDate'"
                [icon]="'far-clock'"
                [(model)]="productMove.expirationDate"
                [inputDisabled]="!!currentStockItem"
              ></form-row-input>
            </div>
          </div>
          <div class="row stock-positions" *ngIf="companyUtil.arePositionsEnabled">
            <div class="col-12 col-sm-4 input-dash position-relative">
              <span class="stock-positions-absolute">{{ 'stock.positions' | translate }}</span>
              <form-row-input
                [label]="'row'"
                [icon]="'far-box'"
                [(model)]="productMove.position1"
                [inputDisabled]="!!currentStockItem"
              ></form-row-input>
              <div class="align-self-center mt-2">-</div>
            </div>
            <div class="col-12 col-sm-4 input-dash">
              <form-row-input
                [label]="'aisle'"
                [icon]="'far-box'"
                [(model)]="productMove.position2"
                [inputDisabled]="!!currentStockItem"
              ></form-row-input>
              <div class="align-self-center mt-2">-</div>
            </div>
            <div class="col-12 col-sm-4">
              <form-row-input
                [label]="'shelf'"
                [icon]="'far-box'"
                [(model)]="productMove.position3"
                [inputDisabled]="!!currentStockItem"
              ></form-row-input>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-6">
              <form-row-input
                [label]="'numberOfItems'"
                [icon]="isUnloadingStock ? 'far-minus' : 'far-plus'"
                [(model)]="productMove.amount"
                [inputType]="'number'"
                [numberMax]="
                  isUnloadingStock && currentStockItem?.quantityStock ? currentStockItem.quantityStock : null
                "
                [numberMin]="1"
                [required]="!this.isUnloadingStock && number(this.productMove.amount) <= 0"
                [requiredCssClass]="submitted && !this.isUnloadingStock && number(this.productMove.amount) <= 0"
              ></form-row-input>
            </div>
            <div class="col-6">
              <form-row-input
                [label]="'stock.operation.purchasePrice'"
                [icon]="'far-money-bill'"
                [(ngModel)]="productMove.purchasePrice"
                [currency]="product.purchaseCurrency"
                [appendUnitCurrency]="true"
                [inputDisabled]="!!currentStockItem"
                [replaceComma]="true"
              ></form-row-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <form-row-textarea [label]="'note'" [icon]="'far-list'" [(model)]="productMove.note"></form-row-textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container class="modal-footer-content">
    <btn
      [btnType]="'submit'"
      [classes]="isUnloadingStock ? ['btn-first-red-inverted'] : ['btn-first-green-inverted']"
      (onEvent)="execute()"
      [icon]="isUnloadingStock ? 'far-minus' : 'far-plus'"
      [label]="isUnloadingStock ? 'out' : 'in'"
      [title]="isUnloadingStock ? ('out' | translate) : ('in' | translate)"
      [isLoading]="loading"
      [spinnerClassesString]="isUnloadingStock ? 'spinner-default-red' : 'spinner-green'"
    ></btn>
  </ng-container>
</modal-container>
